export const deleteEmptyArrayValues = (arr) => arr.filter((el) => el.trim() !== '');
